import React from 'react'
import PropTypes from 'prop-types'
import ArrowIcon from './ArrowIcon'

const TableHeader = props => {
  const showArrowIcon = props.handleOnClick
  return (
    <th className='flex items-center justify-start text-left whitespace-nowrap'>
      {props.title}
      {showArrowIcon
        ? <ArrowIcon
            iconName='arrow_down.svg'
            onClick={props.handleOnClick}
            currentSelected={props.currentSelected}
            title={props.title}
          />
        : null}
    </th>
  )
}

TableHeader.propTypes = {
  title: PropTypes.string
}

export default TableHeader
